export const X_SPACING = 25;
export const Y_SPACING = 48;

// Max layout groups per row before wrapping. A connected stack is one group. Shared
// by applyAutoLayoutToState (as gridLayout's chunkSize) and by
// getDispositionsInterSectionPadding so their row estimates stay in sync.
export const ENTITY_DIAGRAM_GRID_CHUNK_SIZE = 5;

// Target aspect ratio (width / height) for stretched single-entity
// dispositions diagrams in half-width containers. Tuned to the presentation
// 50/50 layout (~0.82 portrait) so the stretched content matches the
// container's aspect ratio and fitView scales uniformly without leaving
// dead space on either axis.
// See getDispositionsInterSectionPadding.
export const SINGLE_ENTITY_DIAGRAM_TARGET_ASPECT_RATIO = 0.82;

export const FIRST_DECEDENT_ID_QUERY_PARAM = 'firstDecedentId';
